import {
  call,
  put,
  takeEvery,
  takeLatest,
  select,
  get,
} from "redux-saga/effects";
import {
  VIEW_PRODUCT,
  VIEW_REVIEW,
  ADD_REVIEW,
  PRODUCT_LIST,
} from "../SagaAction/actions";
import {
  setProductListRequest,
  setProductListSuccess,
  setProductListFailure,
  viewProductRequest,
  viewProductSuccess,
  viewProductFailure,
  addProductReviewFailure,
  addProductReviewRequest,
  addProductReviewSuccess,
  viewProductReviewFailure,
  viewProductReviewSuccess,
  viewProductReviewRequest,
  inScListing,
  getTotalCount,
} from "../Slices/ProductSlice";
import requestApi from "../../utils/request";
import Swal from "sweetalert2";



function* setProductList(params) {
  try {
    yield put(setProductListRequest());
    const {data,meta} = yield requestApi.post("product/list", params?.payload);
    yield put(setProductListSuccess(data));
    yield put(getTotalCount(meta.totalCount))
    yield put(inScListing(data))
    if(typeof params.callback === "function"){
      yield params.callback()
    }
  } catch (e) {
    yield put(setProductListFailure(e));
  }
}
function* viewProductDetails(params) {
  try {
    yield put(viewProductRequest());
    const { data } = yield requestApi.post(`product/view/${params?.payload}`);
    yield put(viewProductSuccess(data));
    if (typeof params?.callback === "function") {
      yield params?.callback(data);
    }
  } catch (e) {
    yield put(viewProductFailure(e));
  }
}

function* addReviewDetails(params) {
  try {
    yield put(addProductReviewRequest());
    const data = yield requestApi.post("add-review", params.payload.data);
    yield put(addProductReviewSuccess(data));
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Review Submitted",
      text: `Thank you for valuable feedback`,
    });
  } catch (e) {
    yield put(addProductReviewFailure(e));
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "Warning",
      text: `${e.message.replace(/([a-z])([A-Z])/g, "$1 $2")}`,
    });
  }
}
function* productViewReview(params) {
  try {
    yield put(viewProductReviewRequest());
    const data = yield requestApi.post("list-review", params.payload);
    yield put(viewProductReviewSuccess(data?.data));
  } catch (e) {
    yield put(viewProductReviewFailure(e));
  }
}

function* ProductSaga() {
  yield takeEvery(VIEW_PRODUCT, viewProductDetails);
  yield takeEvery(ADD_REVIEW, addReviewDetails);
  yield takeEvery(VIEW_REVIEW, productViewReview);
  yield takeLatest(PRODUCT_LIST, setProductList);
}

export default ProductSaga;
